
  <div *ngIf="isLoading | async" class="overlay">
    <div class="spinner">
      <h1><i aria-hidden="true" class="fa fa-certificate fa-spin fa-5x fa-fw text-primary"></i></h1>
      <span class="sr-only">Loading...</span>
    </div>
  </div> 
